<template>
    <div class="main-header__menu-wrap">                       
        <HeadMenu :menu="1" :menuClass="'header-menu'" />
        <HeadMenu :menu="2" :menuClass="'main-menu'" />
    </div>
</template>

<script>
import HeadMenu from '@/components/layoutComponents/HeadMenu.vue'

export default {    
    components:{        
        HeadMenu
    },
    created(){
        this.$store.dispatch("setMenu_headerMenu");  
        this.$store.dispatch("setMenu_mainMenu");  
    }    
}
</script>
